import { Templates } from '../ts/types';

const essence = require('./templates/essence_mwd.html');
const invictus = require('./templates/invictus_mwd.html');
const sixthsense = require('./templates/6thsense_mwd.html');
const magnet = require('./templates/magnet_mwd.html');
const dayAndNight = require('./templates/dayAndNight_mwd.html');
const return_ = require('./templates/return_mwd.html');
const nkotb = require('./templates/nkotb_mwd.html');
const eol = require('./templates/eol_mwd.html');
const aventador = require('./templates/aventador_mwd.html');
const vortex = require('./templates/vortex_mwd.html');
const pumbaa = require('./templates/pumbaa_mwd.html');
const xRace = require('./templates/xRace_mwd.html');
const p3 = require('./templates/p3_mwd.html');
const lazarus = require('./templates/lazarus_mwd.html');
const _90Three = require('./templates/90Three_mwd.html');

const templates: Templates = {
    essence: {
        svg: essence,
        meta: {
            name: 'Essence',
            designer: 'Pim Kusters, Pierre ter Bogt †',
            buildPlans:
                'https://www.kareloh.com/kite-plans/essence-kite/essence-std-plan/',
        },
    },
    invictus: {
        svg: invictus,
        meta: {
            name: 'Invictus',
            designer: 'Davide Equizzi',
            buildPlans:
                'https://www.kareloh.com/kite-plans/invictus/invictus-plan/',
        },
    },
    '6thsense': {
        svg: sixthsense,
        meta: {
            name: '6th Sense',
            designer: 'Davide Equizzi',
            buildPlans:
                'https://www.kareloh.com/kite-plans/2175-2/sixth-sense-plan/',
        },
    },
    magnet: {
        svg: magnet,
        meta: {
            name: 'Magnet',
            designer: 'David Rüger',
            buildPlans:
                'https://www.kareloh.com/kite-plans/magnet-kite/magnet-plan/',
        },
    },
    dayAndNight: {
        svg: dayAndNight,
        meta: {
            name: 'Day&Night',
            designer: 'David Rüger',
            buildPlans:
                'https://www.kareloh.com/kite-plans/day-night-kite/day-night-plan/',
        },
    },
    return: {
        svg: return_,
        meta: {
            name: '[RETURN]',
            designer: 'Birger Garbe',
            buildPlans:
                'https://www.kareloh.com/kite-plans/return/return-plan/',
        },
    },
    nkotb: {
        svg: nkotb,
        meta: {
            name: 'NKOTB',
            designer: 'Fred Blok',
            buildPlans:
                'https://www.kareloh.com/kite-plans/new-kite-on-the-blok/nkotb-plan/',
        },
    },
    eol: {
        svg: eol,
        meta: {
            name: 'EOL',
            designer: 'Birger Garbe',
            buildPlans: 'https://www.kareloh.com/kite-plans/end-of-line/',
        },
    },
    aventador: {
        svg: aventador,
        meta: {
            name: 'Aventador',
            designer: 'Diamondkites',
            // buildPlans: 'tbd',
        },
    },
    vortex: {
        svg: vortex,
        meta: {
            name: 'Vortex',
            designer: 'Christian Derefat',
            buildPlans:
                'http://users.skynet.be/cerfvolanttrick/jeu%20de%20cadre.htm',
        },
    },
    pumbaa: {
        svg: pumbaa,
        meta: {
            name: 'Timon/Pumbaa/Manni',
            designer: 'Peter W. Maternus (PAW)',
            manufacturerContact: 'https://www.facebook.com/peter.w.maternus',
        },
    },
    xRace: {
        svg: xRace,
        meta: {
            name: 'X-Race',
            designer: 'Michael Tiedtke',
            manufacturerContact: 'https://www.spacekites.de/x-race/',
        },
    },
    p3: {
        svg: p3,
        meta: {
            name: 'P3/P2',
            designer: 'Pim Kusters, Pierre ter Bogt †, Peter W. Maternus (P3)',
            buildPlans:
                'https://www.kareloh.com/kite-plans/p2-open-source-trickkite/p3-kite/',
        },
    },
    lazarus: {
        svg: lazarus,
        meta: {
            name: 'Lazarus',
            designer: 'Gabor Nagy',
            buildPlans:
                'https://www.kareloh.com/kite-plans/mugen-kites-lazarus/',
        },
    },
    '90Three': {
        svg: _90Three,
        meta: {
            name: '90Three Family',
            designer: 'KarelOh',
            buildPlans: 'https://www.kareloh.com/kite-plans/90three-family/',
            desingerNotes:
                'I would really appreciate it if builders would stick to the color scheme for the different weight versions. THX!',
        },
        variations: ['STD', 'SUL', 'VTD', 'NOTHING'],
    },
};

export default templates;
